import { call, all, takeEvery, put, fork } from 'redux-saga/effects';
import { notification } from '@isomorphic/shared/isomorphic/components';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';

/*
Log Sagas

TODO: update endpoints to hit TraCS log
*/

export function* logs() {
  yield takeEvery(actions.LOGS, function*({ queryString }) {
    console.log('GET logs queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(SuperFetch.get, 'log?' + queryString);
    console.log('RESPONSE logs:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let logs = response.Data.Logs;
      yield put({
        type: actions.LOG_SUCCESS,
        logs: logs,
      });
    } else {
      yield put({
        type: actions.LOG_ERROR,
        logError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* logFields() {
  yield takeEvery(actions.LOG_FIELDS, function*() {
    console.log('GET logs/fields (no queryString)');
    const response = yield call(SuperFetch.get, 'log/fields');
    console.log('RESPONSE logs/fields:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let fields = response.Data.Fields;
      yield put({
        type: actions.LOG_FIELDS_SUCCESS,
        fields: fields,
      });
    } else {
      yield put({
        type: actions.LOG_ERROR,
        logError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message, '', true); //allow silent if server error
    }
  });
}

/*
Saga loader
*/
export default function* rootSaga() {
  yield all([fork(logFields), fork(logs)]);
}
